import { getLoginType } from './env';

export function getLoginUrl(url?: string) {
    const { location } = window;
    const loginType = getLoginType();
    const returnUrl = encodeURIComponent(url || location.href);
    if (loginType === 3) {
        return `http://passport.jd.com/uc/login?ReturnUrl=${returnUrl}`;
    }
    return `https://ssa.jd.com/sso/login?returnUrl=${returnUrl}`;
}

export function getColorBaseURL(): string {
    const REACT_APP_BASE_COLOR_API: string = process.env.REACT_APP_BASE_COLOR_API || '';
    const REACT_APP_BASE_COLOR_API_HTTPS: string = process.env.REACT_APP_BASE_COLOR_API_HTTPS || '';
    return 'https:' === document.location.protocol
        ? REACT_APP_BASE_COLOR_API_HTTPS
        : REACT_APP_BASE_COLOR_API;
}

export const isProd = () => process.env.REACT_APP_ENV === 'production';

export function getBffBaseURL(): string {
    return 'https:' === document.location.protocol
        ? process.env.REACT_APP_BASE_BFF_API_HTTPS
        : process.env.REACT_APP_BASE_BFF_API;
}

export function getManBaseURL(): string {
    return 'https:' === document.location.protocol
        ? process.env.REACT_APP_BASE_MAN_API_HTTPS
        : process.env.REACT_APP_BASE_MAN_API;
}
